<template>
    <div>
        <Nav></Nav>
        <PageHeader :linkto="'/home'" :linkttitle="'返回'" :title="productName"></PageHeader>
        <b-container v-if="show">

            <FormSelfBox ></FormSelfBox>
            <PersonResultCard :Vipstatus="anaResult.Vipstatus"  :listdata="Prosonality" v-on:sendAction="PaymentPopup"></PersonResultCard>
            <PersonYearResultCard  :listdata="Jugong" :allyear="Allyear" ></PersonYearResultCard>
            <TipsAlert :tipswords="masterTips.tipswords"
                       :status="masterTips.status"
                       :videostatus="masterTips.videostatus"
                       :videosrc="masterTips.videosrc">

            </TipsAlert>
            <PersonAllYearResultCard  :listdata="Allyearresult"></PersonAllYearResultCard>
        </b-container>
        <PaymentModel :product="productName" :point="Price" v-on:sendAction="GoPayment"></PaymentModel>
        <AnaLoading  :show="pageloading"></AnaLoading>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import PageHeader from '@/components/PageHeader.vue'
import Nav from '@/components/Nav.vue'
import TipsAlert from '@/components/TipsAlert.vue'
import FormSelfBox from '@/components/FormSelfBox.vue'
import PersonYearResultCard from '@/components/PersonYearResultCard.vue'
import PersonAllYearResultCard from '@/components/PersonAllYearResultCard.vue'
import PersonResultCard from '@/components/PersonResultCard.vue'
import PaymentModel from '@/components/PaymentModel.vue'
import AnaLoading from '@/components/AnaLoading.vue'
import {alertModel} from '@/service/commuse'

export default {
  name: 'Personality',
  components: {Nav,PageHeader,TipsAlert,FormSelfBox,PersonYearResultCard,PersonAllYearResultCard,PersonResultCard,PaymentModel,AnaLoading},
  data () {
    return {
      productName:'本人個性',
      pageloading:false,
      puid:'1',
      Result:{

      },
      show:false,
      masterTips:{
        status:true,
        videostatus:false,
        videosrc:'',
        tipswords:'（變動歲數）比對您的每個不同歲數，該年不同的變動「歲數以足歲為主」，變動包含：長輩變動、感情變動、身體變動、遷移變動，得知目的預防或注意，才能做好防範。',
      }
    }
  },
  created(){
    this.pageloading=true
    this.$store.dispatch('actionAnaResult', {
      producttype:'PersonalityFree'
    }).then((res) => {
      this.show=true
      this.pageloading=false

    }).catch((res) => {
      this.pageloading=false

    });
  },
  computed:{
    ...mapState(['productdata','anaResult']),
    Price:function () {return this.productdata.data.find(x => x.id === this.puid).price},
    Prosonality:function(){return Object.keys(this.anaResult).length === 0 ? []: this.anaResult.Personality.explantion;},
    Jugong:function(){return Object.keys(this.anaResult).length === 0 ? []: this.anaResult.Jugong.explantion;},
    Allyear:function () {return Object.keys(this.anaResult).length === 0 ? []: this.anaResult.Allyear;},
    Allyearresult:function () {return Object.keys(this.anaResult).length === 0 ? []: this.anaResult.Changeyear;}

  },
  methods: {
    PaymentPopup () {

      this.$bvModal.show('PaymentModel')
    },
    GoPayment () {

      this.pageloading = true
      this.$store.dispatch('actionAnaResult', {
        producttype:'PersonalityVip'
      }).then((res) => {
        this.$store.dispatch('actionGetPoint', {}).then((res) => {
          setTimeout(()=>{
            this.$router.push('/Personality');
            this.pageloading = false
          },1500)
        })
      }).catch((res) => {
        this.pageloading = false
        alertModel(this,'系統訊息','點數餘額不足')
      });
    }

  }
}
</script>

<style scoped>

</style>
